import { useQuery, UseQueryOptions } from 'react-query';

import { getConfig } from '../api/getConfig';

export const useGetConfig = (options: UseQueryOptions<any, Error>) =>
  useQuery<{ data: any }, Error>('config', getConfig, options);
